module.exports = __webpack_public_path__ + "static/img/webp.4c6cd4d8.webp";